import type { FunctionComponent } from 'react';

import { useChatSlotContent } from '../chat-slot-renderers';
import { useChatComposerActive } from './ChatComposerContext';

// Renders content in the collapsed composer's idle slot. The content comes
// from the feature-registered slot renderers, dispatched by the resolved chat
// context. Mirrors `ChatPromptOutlet`.
export const ChatIdleSlotOutlet: FunctionComponent = () => {
    const { resolvedChatContext } = useChatComposerActive();
    const content = useChatSlotContent('idleSlot', resolvedChatContext);

    return <>{content}</>;
};
